import { render, staticRenderFns } from "./RiskQuestionnaire.vue?vue&type=template&id=69ce330b&scoped=true&"
import script from "./RiskQuestionnaire.vue?vue&type=script&lang=ts&"
export * from "./RiskQuestionnaire.vue?vue&type=script&lang=ts&"
import style0 from "./RiskQuestionnaire.vue?vue&type=style&index=0&id=69ce330b&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69ce330b",
  null
  
)

export default component.exports